'use client'
import {TestingType} from '../ui/form'
import {observer} from 'mobx-react'
import React from 'react'

import {PageData} from '@/src/core/domain/entities/page/page-data'

import {Shop} from '@/src/entities/shop'
import {FuncTestingContainer} from './func-testing-container'

export type FunctionalTestingPageContent = {
  labs: Shop[]
  types: TestingType[]
  top_block?: string
  bottom_block?: string
}

export type FunctionalTestingProps = PageData<FunctionalTestingPageContent> & {
  topContent: React.ReactNode
  bottomContent: React.ReactNode
}

export const FunctionalTestingScreen: React.FC<FunctionalTestingProps> = observer(
  ({topContent, bottomContent}) => {
    return (
      <>
        {topContent}
        <FuncTestingContainer />
        {bottomContent}
      </>
    )
  },
)
